import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import './actionButtons.less';


const allowedSearchTypes = ['Bankruptcy'];

class ActionButtons extends Component {
    render() {
        return (
            <div className="action-btn-container">
                <input type="button"
                       id="pacer-search-submit"
                       disabled={ ! this.props.enabled }
                       value="PACER Search"
                       className="form-submit green action-btn-search"
                       onClick={this.props.searchClickHandler}/>

                {allowedSearchTypes.indexOf(this.props.searchType) !== -1 && (
                    <input
                        type="button"
                        id="local-search-submit"
                        value="Local Court Search"
                        className={`form-submit action-btn-search ${!this.props.isLocalSearchAllowed || ! this.props.enabled ? 'form-button-disabled' : ''}`}
                        onClick={this.props.localSearchClickHandler}
                    />
                )}

                <input type="button"
                       id="clear-btn"
                       disabled={ ! this.props.enabled }
                       value="Clear"
                       className="form-submit"
                       onClick={this.props.resetFilters} />
            </div>
        )
    }
}

ActionButtons.defaultProps = {
  isLocalSearchAllowed: false,
  searchClickHandler: () => null,
  localSearchClickHandler: () => null,
};

ActionButtons.propTypes = {
  searchTyp: PropTypes.string,
  isLocalSearchAllowed: PropTypes.bool,
  searchClickHandler: PropTypes.func,
  localSearchClickHandler: PropTypes.func,
};



function mapStateToProps(state) {
  // TODO: we should also make the searchClickHandler action be ignored when we are in middle of searching
  //       if say we have some other way of triggering it other than action buttons...
  return {enabled: ! state.get('loadingSpinner')}
}

export default connect(mapStateToProps)(ActionButtons)



// WEBPACK FOOTER //
// ./src/components/search/FormElements/actionButtons/ActionButtons.js